import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';
import type { SignatureData } from 'types/entities/signatureData';

export interface SignPatchOptions {
  recordClass: 'Addendum' | 'Document';
  password?: string;
  recordId: number;
  signatures: SignatureData[];
  pdfData: Record<string, string>;
  publishAcknowledgement?: boolean;
}

const apiPath = '/api/v1/sign';

function signApi(path: string) {
  return {
    path,
    PATCH: ({ signatures, ...data }: SignPatchOptions) =>
      api.patch<JsonApiResponseSingle>(path, {
        data: {
          attributes: {
            ...mapFormData(data),
            signatures: signatures.map(signature => mapFormData(signature)),
          },
        },
      }),
  };
}

function sign() {
  return signApi(apiPath);
}

export { sign };
